export const lessonCategories = [
  "全部",
  "入门导览",
  "核心基础",
  "进阶技巧",
  "实战案例",
  "完整版",
];

export const lessons = [
  {
    id: "lesson-01",
    no: "第 01 课",
    title: "系列导览：一次看懂秘密教学的整体结构",
    category: "入门导览",
    duration: "12 分 40 秒",
    format: "视频",
    level: "入门",
    summary:
      "开篇总览，先交代整个系列分成哪几个阶段、每个阶段解决什么问题，帮助第一次接触的用户建立全局地图。",
    tags: ["系列结构", "学习顺序", "新手必看"],
    points: [
      "系列三大阶段：入门导览、核心基础、进阶实战",
      "每一课的定位与先后依赖关系",
      "推荐先看本课，再进入核心基础部分",
    ],
  },
  {
    id: "lesson-02",
    no: "第 02 课",
    title: "术语与背景：进入系列前需要知道的常识",
    category: "入门导览",
    duration: "15 分 20 秒",
    format: "图文",
    level: "入门",
    summary:
      "把系列中反复出现的专有名词、缩写和背景设定集中解释，避免后续内容因术语不熟而卡壳。",
    tags: ["术语表", "背景知识", "速查"],
    points: [
      "常见术语一页速查表",
      "各阶段会反复出现的关键概念",
      "阅读顺序与配图说明",
    ],
  },
  {
    id: "lesson-03",
    no: "第 03 课",
    title: "基础方法一：如何高效搭建学习框架",
    category: "核心基础",
    duration: "22 分 05 秒",
    format: "视频",
    level: "入门",
    summary:
      "从零开始讲解如何为整个系列搭建学习框架，先搭骨架再填内容，让后续每一课都能对号入座。",
    tags: ["学习框架", "方法论", "入门"],
    points: [
      "框架三要素：目标、路径、检查点",
      "如何为自己安排每课的观看节奏",
      "配套练习的去向与整理方式",
    ],
  },
  {
    id: "lesson-04",
    no: "第 04 课",
    title: "基础方法二：核心概念拆解与示例",
    category: "核心基础",
    duration: "25 分 30 秒",
    format: "视频",
    level: "基础",
    summary:
      "围绕系列中最核心的几个概念做拆解，每个概念配一个示例，讲清楚「是什么」和「怎么用」。",
    tags: ["核心概念", "示例讲解", "拆解"],
    points: [
      "核心概念逐个拆解",
      "每个概念配真实示例",
      "常见理解偏差提示",
    ],
  },
  {
    id: "lesson-05",
    no: "第 05 课",
    title: "基础方法三：常见误区与纠正",
    category: "核心基础",
    duration: "18 分 15 秒",
    format: "视频",
    level: "基础",
    summary:
      "汇总初学者最容易踩的坑，逐条给出纠正思路，让基础阶段少走弯路。",
    tags: ["误区", "纠正", "避坑"],
    points: [
      "七个高频误区清单",
      "每条误区的正确做法",
      "自查小练习",
    ],
  },
  {
    id: "lesson-06",
    no: "第 06 课",
    title: "进阶技巧一：把零散知识点串成体系",
    category: "进阶技巧",
    duration: "28 分 50 秒",
    format: "视频",
    level: "进阶",
    summary:
      "当基础概念都学完之后，如何把散落的知识点整理成可复用的体系，形成自己的知识网络。",
    tags: ["知识体系", "串联", "进阶"],
    points: [
      "知识点之间的关系梳理",
      "用一张图看懂整个系列",
      "如何做长效笔记",
    ],
  },
  {
    id: "lesson-07",
    no: "第 07 课",
    title: "进阶技巧二：复杂案例的分解思路",
    category: "进阶技巧",
    duration: "31 分 10 秒",
    format: "视频",
    level: "进阶",
    summary:
      "面对一个复杂问题时，如何拆成若干可处理的小步骤，逐步推进而不至于中途迷失方向。",
    tags: ["案例分解", "思路", "拆解"],
    points: [
      "从问题到步骤的分解方法",
      "分解时常见的两种误区",
      "完整推演一遍全过程",
    ],
  },
  {
    id: "lesson-08",
    no: "第 08 课",
    title: "进阶技巧三：效率工具与流程优化",
    category: "进阶技巧",
    duration: "24 分 00 秒",
    format: "图文",
    level: "进阶",
    summary:
      "介绍配合本系列使用的效率工具与整理流程，把重复性的整理工作压缩到最短。",
    tags: ["效率工具", "流程", "整理"],
    points: [
      "常用工具清单与用途",
      "一套可复用的整理流程",
      "模板分享与使用说明",
    ],
  },
  {
    id: "lesson-09",
    no: "第 09 课",
    title: "实战案例一：从需求到落地的完整流程",
    category: "实战案例",
    duration: "35 分 45 秒",
    format: "视频",
    level: "进阶",
    summary:
      "用一个完整的实战案例，把前面学的方法串联起来，走一遍从提出需求到最终落地的全过程。",
    tags: ["实战", "全流程", "案例"],
    points: [
      "真实场景的背景设定",
      "逐步推演完整流程",
      "关键节点的取舍说明",
    ],
  },
  {
    id: "lesson-10",
    no: "第 10 课",
    title: "实战案例二：多场景综合演练",
    category: "实战案例",
    duration: "33 分 20 秒",
    format: "视频",
    level: "进阶",
    summary:
      "把同一套方法放到不同场景中演练，比较不同场景下的处理差异，检验方法是否真正掌握。",
    tags: ["多场景", "演练", "对比"],
    points: [
      "三个不同场景的对照演练",
      "差异点与共性总结",
      "迁移使用时的注意事项",
    ],
  },
  {
    id: "lesson-11",
    no: "第 11 课",
    title: "实战案例三：复盘与优化记录",
    category: "实战案例",
    duration: "27 分 35 秒",
    format: "视频",
    level: "进阶",
    summary:
      "实战完成之后的复盘环节，记录哪些做法有效、哪些需要调整，形成属于自己的优化清单。",
    tags: ["复盘", "优化", "记录"],
    points: [
      "复盘的四步结构",
      "如何写一份可执行的优化清单",
      "长期坚持复盘的方式",
    ],
  },
  {
    id: "lesson-12",
    no: "第 12 课",
    title: "拓展专题：延伸阅读与相关资料",
    category: "核心基础",
    duration: "19 分 50 秒",
    format: "图文",
    level: "基础",
    summary:
      "为想进一步深入的用户整理延伸阅读方向与相关资料类型，指明可以继续探索的边界。",
    tags: ["延伸阅读", "资料", "拓展"],
    points: [
      "延伸阅读的三个方向",
      "资料筛选与辨别方法",
      "与主线的衔接关系",
    ],
  },
  {
    id: "lesson-13",
    no: "第 13 课",
    title: "阶段测评一：基础篇自测清单",
    category: "核心基础",
    duration: "16 分 10 秒",
    format: "图文",
    level: "基础",
    summary:
      "完成核心基础部分后的自测清单，逐项对照确认是否真的掌握，再决定是否进入进阶阶段。",
    tags: ["测评", "自测", "基础"],
    points: [
      "基础篇十项自测条目",
      "每项的达标标准",
      "未达标时的补课建议",
    ],
  },
  {
    id: "lesson-14",
    no: "第 14 课",
    title: "阶段测评二：进阶篇自测清单",
    category: "进阶技巧",
    duration: "17 分 25 秒",
    format: "图文",
    level: "进阶",
    summary:
      "进阶部分结束后的自测清单，重点检验方法能否在陌生场景中举一反三。",
    tags: ["测评", "自测", "进阶"],
    points: [
      "进阶篇八项自测条目",
      "举一反三的检验方式",
      "进阶到完整版的过渡建议",
    ],
  },
  {
    id: "lesson-15",
    no: "第 15 课",
    title: "完整版整合：全系列串联与总复习",
    category: "完整版",
    duration: "52 分 30 秒",
    format: "视频",
    level: "完整",
    summary:
      "把第一课到进阶篇的全部内容重新串联成一条主线，做一次完整的总复习，查漏补缺。",
    tags: ["完整版", "总复习", "串联"],
    points: [
      "全系列主线回顾",
      "各阶段之间的衔接点",
      "重点内容的二次强调",
    ],
  },
  {
    id: "lesson-16",
    no: "完整版",
    title: "完整版合辑：第一课到最后一课全收录",
    category: "完整版",
    duration: "合集 · 约 6 小时",
    format: "视频",
    level: "完整",
    summary:
      "把整个系列按顺序整合成一个完整合辑，适合希望一次看完、系统过一遍全部内容的用户。",
    tags: ["完整版", "合辑", "全收录"],
    points: [
      "按顺序整合全部集数",
      "章节标记方便跳转",
      "适合系统学习与回顾",
    ],
  },
];